interface ProductVariantModel {
  id: number;
  name: string;
  price: number;
  sku: string;
  traits: string;
}
export enum ExtraProductReasonEnum {
  SUMMER_2026 = 'summer_2026',
}

export interface ExtraProductModel {
  id: number;
  product_variant?: ProductVariantModel;
  units: number;
  product_text?: string;
  fixed_price?: number;
  reason?: ExtraProductReasonEnum | null;
}
